import { Space, Popover, Checkbox, Alert } from "antd";
import CardPartial from "../partials/Card";
import { UserFormInterface } from "../definitions";

interface Step4Props {
  invitations: any[];
  userForm: UserFormInterface;
  activeInvite: string | null;
  activeTime: string | null;
  isPosting: boolean;
  errors: { [key: string]: string };
  apiBaseUrl: string;
  onInvitationSelect: (inviteUuid: string) => void;
  onPrintInvitesChange: (checked: boolean) => void;
  onPhoneInInvitationChange: (checked: boolean) => void;
}

const Step4: React.FC<Step4Props> = ({
  invitations,
  userForm,
  activeInvite,
  activeTime,
  isPosting,
  errors,
  apiBaseUrl,
  onInvitationSelect,
  onPrintInvitesChange,
  onPhoneInInvitationChange,
}) => {
  const isPrintInvitesChecked = userForm.print_invites === "true";
  const isPhoneInInvitationChecked = userForm.phone_in_invitation === "true";
  const hasInvitations = invitations.length > 0;

  return (
    <CardPartial
      isPosting={isPosting}
      title="Gimtadienio kvietimai"
      active_time={activeTime}
    >
      {hasInvitations && (
        <>
          {errors["invitation_type"] !== undefined && (
            <Alert
              type="error"
              className="mb-2"
              message="Būtina pasirinkti pakvietimą"
              banner
            />
          )}
          <div
            style={{
              textAlign: "center",
              marginBottom: "12px",
              color: "#666",
              fontSize: "14px",
            }}
          >
            Paspauskite ant kvietimo, kad jį pasirinktumėte:
          </div>
          <Space
            style={{ width: "100%", justifyContent: "center" }}
            wrap
            direction="horizontal"
          >
            {invitations.map((invite) => (
              <Popover
                placement="top"
                key={invite.uuid}
                content={
                  <img
                    src={`${apiBaseUrl}/api/invitations/${invite.uuid}/thumbnail`}
                    alt="Kvietimas"
                    width={170}
                  />
                }
              >
                <img
                  style={{
                    maxWidth: "60px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    transform:
                      activeInvite === invite.uuid ? "scale(1.05)" : "scale(1)",
                  }}
                  className={`rounded-md ${
                    activeInvite !== invite.uuid
                      ? "grayscale hover:grayscale-0"
                      : "border-2 border-green-600"
                  }`}
                  src={`${apiBaseUrl}/api/invitations/${invite.uuid}/thumbnail`}
                  alt={`Kvietimas nr ${invite.uuid}`}
                  onClick={() => onInvitationSelect(invite.uuid)}
                />
              </Popover>
            ))}
          </Space>
          <Space className="w-full mt-2 text-[#D33092]">
            <Checkbox
              checked={isPrintInvitesChecked}
              onChange={(e) => onPrintInvitesChange(e.target.checked)}
            >
              Užsisakau spausdintus kvietimus ir juos atsiimsiu „Pramogų lofte"
            </Checkbox>
          </Space>
          <Space className="w-full mt-4 text-[#D33092]">
            <Checkbox
              checked={isPhoneInInvitationChecked}
              disabled={!isPrintInvitesChecked}
              onChange={(e) => onPhoneInInvitationChange(e.target.checked)}
            >
              Sutinku, kad mano telefono numeris būtų spausdinamas kvietimuose, jog
              svečiai galėtų pranešti, ar dalyvaus šventėje.
            </Checkbox>
          </Space>
        </>
      )}
    </CardPartial>
  );
};

export default Step4;
